export enum SessionTitles {
  ACCESS_TOKEN = 'accessToken',
  SESSION = 'session',
  PERMISSIONS = 'permissions',
  PREFERENCES = 'preferences',
}
